import { getLocalStorage, getCookie } from './browserHelpers';

export function getBrowserZipcode() {
  const akamaiLocationData = getCookie('x-kbb-aka-data');
  let zipCode = '';
  if (akamaiLocationData) {
    const decodedLocationData = decodeURI(akamaiLocationData);
    const akamaiSplit = decodedLocationData?.split('|');
    const akamaiZip = akamaiSplit[2];
    if (akamaiZip && akamaiZip?.length === 5) {
      zipCode = akamaiZip;
    }
  }
  if (!zipCode) {
    const peDataJSON = getLocalStorage('pe_data');
    const peData = peDataJSON ? JSON.parse(peDataJSON) : '';
    if (peData) {
      const pePrimaryZip = peData?.personalization?.primaryMarketZip;
      if (pePrimaryZip) {
        zipCode = pePrimaryZip;
      }
    }
  }
  if (!zipCode) {
    zipCode = getCookie('ZipCode') || getCookie('PersistentZipCode') || '';
  }
  return zipCode;
}

const defaultZip = getBrowserZipcode();
export default defaultZip;
